// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MapOutline from '../_raw/ui/icon_map_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MapOutline);
